import { createDirectLine } from 'botframework-webchat';
import { useEffect, useState } from 'react';
export const useDirectLine = (webChatConfig) => {
    const [directLine, setDirectLine] = useState();
    useEffect(() => {
        if (webChatConfig) {
            const directLineOptions = Object.assign(Object.assign({}, webChatConfig.directLineConfig), { watermark: '-', webSocket: webChatConfig.directLineConfig.webSocket ? undefined : false });
            setDirectLine(createDirectLine(directLineOptions));
        }
        else {
            setDirectLine(undefined);
        }
    }, [webChatConfig]);
    return directLine;
};
//# sourceMappingURL=useDirectLine.js.map